import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from '~components/page-section';
import { smallContentGrid } from '~styles/shared';
import { Flex, Icon } from '@phishtool/ui';
import { StyledCard } from './styled';
import { Heading } from '~components/heading';
import { Paragraph } from '~components/paragraph';
const iconHeight = 54;
const iconMap = {
    ingestion: {
        name: 'email-ingestion',
        width: 62,
    },
    parsing: {
        name: 'parsing',
        width: 62,
    },
    reporting: {
        name: 'reporting',
        width: 51,
    },
};
const CardComponent = ({ card }) => {
    const icon = iconMap[card.type];
    return (_jsxs(StyledCard, { children: [_jsx(Flex, { justify: "center", spacer: "x3", children: _jsx(Icon, { name: icon.name, size: { width: icon.width, height: iconHeight }, color: "silverPearl" }) }), _jsx(Heading, { level: 3, as: 4, spacer: "x3", children: card.title }), card.description.split('\n').map((paragraph, index) => (_jsx(Paragraph, { size: "large", children: paragraph }, index)))] }));
};
const ThreeCardSection = ({ id, title, intro, cards }) => (_jsx(PageSection, { id: id, title: title, intro: intro, headerSpacer: ['x6', null, 'x9'], contentGrid: smallContentGrid, children: _jsx(Flex, { direction: ['column', null, 'row'], gap: "x3", justify: "space-between", children: cards.map((card) => (_jsx(CardComponent, { card: card }, card.id))) }) }));
export default ThreeCardSection;
